import { WidgetConfig } from '@interfaces/widget'

// TODO: Should add other checks here
export const checkValidConfig = (config: WidgetConfig) => {
  return true
}
